var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var contentForFiles = require('../../utils/content-for-files');

var WTError = require('../../error');

var logger = require('../../config/logger');

var _require = require('../models'),
    futureTransfer = _require.futureTransfer,
    RemoteTransfer = _require.RemoteTransfer;

module.exports = function (_ref) {
  var request = _ref.request,
      routes = _ref.routes,
      uploadFileToTransfer = _ref.uploadFileToTransfer,
      finalizeTransfer = _ref.finalizeTransfer;

  /**
   * Check if the user also passed the content for files.
   * In that case, we can upload the files in one go.
   *
   * @param {Array} files A list of file object, containing name, size and maybe content
   */
  function shouldUploadFiles(files) {
    return files.reduce(function (uploadFiles, file) {
      return uploadFiles && Boolean(file.content);
    }, true);
  }
  /**
   * Given the content of the files and a remote transfer,
   * upload all the files and finalize the transfer.
   * @param   {Array}   filesContent   An array containing the content of each file
   * @param   {Object}  remoteTransfer A transfer object
   * @returns {Promise}                A transfer object
   */


  function uploadFilesAndFinalize(_x, _x2) {
    return _uploadFilesAndFinalize.apply(this, arguments);
  }
  /**
   * Creates a new transfer
   * @param   {Object}  transfer A transfer object containing files.
   * @returns {Promise}          A transfer object
   */


  function _uploadFilesAndFinalize() {
    _uploadFilesAndFinalize = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(filesContent, remoteTransfer) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all(remoteTransfer.files.map(function (file) {
                return uploadFileToTransfer(remoteTransfer, file, filesContent[file.name]);
              }));

            case 2:
              _context2.next = 4;
              return finalizeTransfer(remoteTransfer);

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
    return _uploadFilesAndFinalize.apply(this, arguments);
  }

  return (
    /*#__PURE__*/
    function () {
      var _createTransfer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(transfer) {
        var response, remoteTransfer, filesContent;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                logger.info('Creating a new transfer.');
                _context.next = 4;
                return request.send(routes.transfers.create, futureTransfer(transfer));

              case 4:
                response = _context.sent;
                logger.info("Transfer created with id ".concat(response.id, "."));
                remoteTransfer = new RemoteTransfer(response); // If the files array contains the content of the file
                // lets upload directly, without asking the user to do it,
                // and finalize the transfer in one go.

                if (!shouldUploadFiles(transfer.files)) {
                  _context.next = 12;
                  break;
                }

                filesContent = contentForFiles(transfer.files);
                _context.next = 11;
                return uploadFilesAndFinalize(filesContent, remoteTransfer);

              case 11:
                return _context.abrupt("return", _context.sent);

              case 12:
                return _context.abrupt("return", remoteTransfer);

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](0);
                throw new WTError('There was an error when creating the transfer.', _context.t0);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 15]]);
      }));

      function createTransfer(_x3) {
        return _createTransfer.apply(this, arguments);
      }

      return createTransfer;
    }()
  );
};